/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{ManagedFBOAttachment as t}from"./ManagedFBOAttachment.js";import{AttachmentType as e}from"./ManagedFBObject.js";class r extends t{constructor(){super(...arguments),this.type=e.DEPTH}}export{r as ManagedDepthAttachment};
